/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React base styles

// Material Dashboard 2 PRO React helper functions
import pxToRem from "assets/theme/functions/pxToRem";


const tab = {
  styleOverrides: {
    root: {
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
      flex: "1 1 auto",
      textAlign: "center",
      maxWidth: "unset !important",
      minWidth: "unset !important",
      minHeight: "unset !important",
      fontSize: "13px",
      fontWeight: 600,
      textTransform: "none",
      lineHeight: "inherit",
      padding: `${pxToRem(7)} ${pxToRem(14)}`,
      borderRadius: "7px",
      color: "#64748B !important",
      opacity: "1 !important",
      transition: "color 0.2s ease",
      "&.Mui-selected": {
        color: "#FFFFFF !important",
      },
      // Sekme içindeki metin / ikonlar kendi rengini taşıyabilir; seçiliyken lacivert zeminde okunur kalsın
      "&.Mui-selected > *:not(.MuiTouchRipple-root), &.Mui-selected .MuiTypography-root, &.Mui-selected .material-icons-round, &.Mui-selected .material-icons": {
        color: "#FFFFFF !important",
      },
      "&:hover:not(.Mui-selected)": {
        color: "#0F172A !important",
      },

      "& .material-icons, .material-icons-round": {
        marginBottom: "0 !important",
        marginRight: pxToRem(6),
      },

      "& svg": {
        marginBottom: "0 !important",
        marginRight: pxToRem(6),
      },
    },

    labelIcon: {
      paddingTop: pxToRem(4),
    },
  },
};

export default tab;
